import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MatConnectedDialog, MatConnectedDialogMobileAnimation } from 'src/app/shared/service/connected-dialog';
import { NotificationService } from '../notification.service';
import { NotificationDialog } from './notification.dialog';

export enum DialogType {
  DETAIL = 'detail',
  OVERVIEW = 'overview',
}

@Injectable({ providedIn: 'root' })
export class NotificationDialogService {
  constructor(
    public notificationService: NotificationService,
    private matConnectedDialog: MatConnectedDialog,
  ) {}

  public detailTitle = '';

  public detailContent = '';

  public detailSendTime = '';

  public dialogType$: BehaviorSubject<DialogType> = new BehaviorSubject<DialogType>(DialogType.OVERVIEW);

  public tabIndex$: BehaviorSubject<number> = new BehaviorSubject<number>(0); //当前tab索引

  public reset() {
    this.dialogType$.next(DialogType.OVERVIEW);
    this.tabIndex$.next(0);
  }

  onReadMsg(id: number) {
    this.notificationService.readNotice({ idList: [id] }).subscribe(() => {
      this.notificationService.getNoticeCounts();
      this.notificationService.reLoadData$.next(true);
    });
  }

  onReadAllMsg(ids: number[]) {
    this.notificationService.readNotice({ idList: ids }).subscribe(() => {
      this.notificationService.getNoticeCounts();
      this.notificationService.reLoadData$.next(true);
    });
  }

  openNotification(tabIndex: number = 0) {
    this.tabIndex$.next(tabIndex);
    this.matConnectedDialog.open(NotificationDialog, {
      mobileAnimation: MatConnectedDialogMobileAnimation.SLIDE_UP,
      mobileFixedBottom: true,
    });
  }
}
